import Products from 'merchandise-lib/constants/Product';
import { useHasAnyCoreSeatsInProductDetails, useHasAnySuiteBundlesInProductDetails } from '../v2/hooks/product/useProductDetails';
import { useIsDeveloperPortal, useIsSeatsUser } from '../v2/hooks/user/useUserInfo';
import { useGlobalLoading } from './loadingHooks';
import { usePurchaseableProductsForApiName } from './useBulkPurchaseOptions';
export const useMismatchedCohortingCheck = () => {
  const isAppReady = useGlobalLoading();
  const hasSeatsAccessScope = useIsSeatsUser();
  const isDeveloperPortal = useIsDeveloperPortal();
  const {
    hasAnyCoreSeats: hasAnyCoreSeatsInProductData,
    loading: isCoreSeatsProductDataLoading
  } = useHasAnyCoreSeatsInProductDetails();
  const {
    hasAnySuiteBundles: hasAnySuiteBundlesInProductData,
    loading: isSuiteBundlesProductDataLoading
  } = useHasAnySuiteBundlesInProductDetails();
  const {
    purchaseOptionsForApiName: purchaseOptionsForCoreSeatsStarter,
    loading: isCoreSeatsStarterInPopDataLoading,
    error: isCoreSeatsStarterInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: Products.CORE_SEATS_STARTER
  });
  const hasCoreSeatsStarterInPopData = !isCoreSeatsStarterInPopDataLoading && !isCoreSeatsStarterInPopDataError && !!(purchaseOptionsForCoreSeatsStarter !== null && purchaseOptionsForCoreSeatsStarter !== void 0 && purchaseOptionsForCoreSeatsStarter.length);
  const {
    purchaseOptionsForApiName: purchaseOptionsForCoreSeatsProfessional,
    loading: isCoreSeatsProfessionalInPopDataLoading,
    error: isCoreSeatsProfessionalInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: Products.CORE_SEATS_PROFESSIONAL
  });
  const hasCoreSeatsProfessionalInPopData = !isCoreSeatsProfessionalInPopDataLoading && !isCoreSeatsProfessionalInPopDataError && !!(purchaseOptionsForCoreSeatsProfessional !== null && purchaseOptionsForCoreSeatsProfessional !== void 0 && purchaseOptionsForCoreSeatsProfessional.length);
  const {
    purchaseOptionsForApiName: purchaseOptionsForCoreSeatsEnterprise,
    loading: isCoreSeatsEnterpriseInPopDataLoading,
    error: isCoreSeatsEnterpriseInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: Products.CORE_SEATS_ENTERPRISE
  });
  const hasCoreSeatsEnterpriseInPopData = !isCoreSeatsEnterpriseInPopDataLoading && !isCoreSeatsEnterpriseInPopDataError && !!(purchaseOptionsForCoreSeatsEnterprise !== null && purchaseOptionsForCoreSeatsEnterprise !== void 0 && purchaseOptionsForCoreSeatsEnterprise.length);
  const hasAnyCoreSeatsProductsInPopData = hasCoreSeatsStarterInPopData || hasCoreSeatsProfessionalInPopData || hasCoreSeatsEnterpriseInPopData;
  const {
    purchaseOptionsForApiName: purchaseOptionsForCrmSuiteStarter,
    loading: isCrmSuiteStarterInPopDataLoading,
    error: isCrmSuiteStarterInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: Products.CRM_SUITE_STARTER_BUNDLE
  });
  const hasCrmSuiteStarterInPopData = !isCrmSuiteStarterInPopDataLoading && !isCrmSuiteStarterInPopDataError && !!(purchaseOptionsForCrmSuiteStarter !== null && purchaseOptionsForCrmSuiteStarter !== void 0 && purchaseOptionsForCrmSuiteStarter.length);
  const {
    purchaseOptionsForApiName: purchaseOptionsForCrmSuiteProfessional,
    loading: isCrmSuiteProfessionalInPopDataLoading,
    error: isCrmSuiteProfessionalInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: Products.CRM_SUITE_PROFESSIONAL_BUNDLE
  });
  const hasCrmSuiteProfessionalInPopData = !isCrmSuiteProfessionalInPopDataLoading && !isCrmSuiteProfessionalInPopDataError && !!(purchaseOptionsForCrmSuiteProfessional !== null && purchaseOptionsForCrmSuiteProfessional !== void 0 && purchaseOptionsForCrmSuiteProfessional.length);
  const {
    purchaseOptionsForApiName: purchaseOptionsForCrmSuiteEnterprise,
    loading: isCrmSuiteEnterpriseInPopDataLoading,
    error: isCrmSuiteEnterpriseInPopDataError
  } = usePurchaseableProductsForApiName({
    apiName: Products.CRM_SUITE_ENTERPRISE_BUNDLE
  });
  const hasCrmSuiteEnterpriseInPopData = !isCrmSuiteEnterpriseInPopDataLoading && !isCrmSuiteEnterpriseInPopDataError && !!(purchaseOptionsForCrmSuiteEnterprise !== null && purchaseOptionsForCrmSuiteEnterprise !== void 0 && purchaseOptionsForCrmSuiteEnterprise.length);
  const hasAnySuiteBundleProductsInPopData = hasCrmSuiteStarterInPopData || hasCrmSuiteProfessionalInPopData || hasCrmSuiteEnterpriseInPopData;
  const isSeatsLoading = isCoreSeatsProductDataLoading || isCoreSeatsStarterInPopDataLoading || isCoreSeatsProfessionalInPopDataLoading || isCoreSeatsEnterpriseInPopDataLoading;
  const isSuiteBundlesLoading = isSuiteBundlesProductDataLoading || isCrmSuiteStarterInPopDataLoading || isCrmSuiteProfessionalInPopDataLoading || isCrmSuiteEnterpriseInPopDataLoading;
  const isLoading = !isAppReady || isSeatsLoading || isSuiteBundlesLoading;
  const preSeatsCohort = !hasAnyCoreSeatsProductsInPopData && !hasAnyCoreSeatsInProductData && !hasSeatsAccessScope;
  const seatsCohort = (hasSeatsAccessScope || isDeveloperPortal) && hasAnyCoreSeatsInProductData && hasAnyCoreSeatsProductsInPopData;
  const hasMismatchedProductsAndPopData = hasAnySuiteBundlesInProductData !== hasAnySuiteBundleProductsInPopData || hasAnyCoreSeatsInProductData !== hasAnyCoreSeatsProductsInPopData;
  const hasMismatchedSeatsGating = !(preSeatsCohort || seatsCohort);
  return {
    loading: isLoading,
    hasMismatchedProductsAndPopData,
    hasMismatchedSeatsGating
  };
};